import { api } from '@shared/api/api';
import { toQueryString } from '@shared/api/helpers';
import { PaginatedResourceResponse, PartialQuery } from '@shared/api/types';

type CrewMember = App.Domain.CrewMember.Data.CrewMemberData;

export const getTimeTrackingGroupCrewMembers = (timeTrackingGroupId: number, query?: PartialQuery) => {
  const endpoint = `time-tracking-groups/${timeTrackingGroupId}/crew-members`;
  const url = query ? `${endpoint}?${toQueryString(query)}` : endpoint;

  return api.get<PaginatedResourceResponse<CrewMember>>(url);
};
